/**
 * Layout intermedio del entorno EMITIDAS. Mismo patrón que RecibidasLayout,
 * para que la app tenga el mismo esqueleto visual en ambos entornos.
 * Por ahora sólo hay "Desde Excel"; futuros modos (PDF, API…) se añadirán aquí.
 */
import { NavLink, Outlet } from "react-router-dom";
import { FileSpreadsheet, FileText } from "lucide-react";
import { cn } from "@/lib/utils";
import BackButton from "@/components/BackButton";

const tabClass = ({ isActive }: { isActive: boolean }) =>
  cn(
    "inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md transition-colors border",
    isActive
      ? "bg-primary text-primary-foreground border-primary"
      : "bg-background text-muted-foreground border-transparent hover:bg-muted hover:text-foreground",
  );

const EmitidasLayout = () => {
  return (
    <div className="flex flex-col min-h-[calc(100vh-2.25rem)]">
      <nav className="border-b bg-muted/30 px-4 py-2 flex items-center gap-2">
        <BackButton variant="ghost" className="text-xs" />
        <span className="text-[10px] uppercase tracking-wider text-muted-foreground mr-2">
          Emitidas
        </span>
        <NavLink to="/emitidas/pdf" className={tabClass} end>
          <FileText className="h-3.5 w-3.5" />
          Desde PDF
        </NavLink>
        <NavLink to="/emitidas/excel" className={tabClass} end>
          <FileSpreadsheet className="h-3.5 w-3.5" />
          Desde Excel
        </NavLink>
      </nav>
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
};

export default EmitidasLayout;
